import { getAxiosInstance } from '../client';
export const challengeQueries = {
    /**
     * Per-session progress snapshot. The challenge panel polls this at 1500ms
     * while there is still an active task — mirrors `invoice-run.status`'s
     * poll cadence so the UX feels consistent.
     */
    progress: (sessionId) => getAxiosInstance()
        .get(`/challenge/session/${sessionId}/progress`)
        .then((r) => r.data),
    /**
     * Stamps consent acceptance. The `SessionRecorder` only starts rrweb once
     * this resolves.
     */
    acceptConsent: (sessionId) => getAxiosInstance()
        .post(`/challenge/session/${sessionId}/consent`)
        .then((r) => r.data),
    /**
     * Posts one rrweb batch. Used by the live recorder during the session;
     * the tab-close flush uses `navigator.sendBeacon` directly to the same
     * URL with the same JSON body.
     */
    sendReplayBatch: (sessionId, seq, events) => getAxiosInstance()
        .post(`/challenge/session/${sessionId}/replay`, {
        seq,
        events,
    })
        .then((r) => r.data),
    /**
     * Internal-only — SUPERADMIN review of the concatenated rrweb stream.
     */
    getReplay: (sessionId) => getAxiosInstance()
        .get(`/challenge/session/${sessionId}/replay`)
        .then((r) => r.data),
};
export const challengeKeys = {
    all: () => ['challenge'],
    progress: (sessionId) => [...challengeKeys.all(), 'progress', sessionId],
    replay: (sessionId) => [...challengeKeys.all(), 'replay', sessionId],
};
/**
 * Stop polling once every task is COMPLETED (`activeTaskId === null`). While
 * a task is still active, refetch at 1500ms.
 */
export function challengeProgressPollInterval(data) {
    if (!data)
        return 1500;
    return data.activeTaskId === null ? false : 1500;
}
//# sourceMappingURL=challenge.queries.js.map